import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo'; 
import BuilderCard from '../../builder/components/builder-card';
import ProductCard from '../../builder/components/product-card';
import { AddSector } from '../../../../actions/booking';
import BuilderSlidePanel from '../../builder/components/builder-slide-panel';
import { bindActionCreators } from 'redux';
import { ToggleSlidingPanel } from '../../../../actions/utils';
import dayjs from 'dayjs';
import CloseSvg from '../../../shared/UI/closeSvg';
import { getCyoaID } from '../../../../helpers/cyoaHelper';
import _last from 'lodash/last';
import { timeConverter } from '../../../../helpers/utils';
const queryString = require('query-string');


class DestinationPanel extends PureComponent {

    constructor(props){
        super(props);
        this.onAddDestination = this.onAddDestination.bind(this);
    }

    onAddDestination(type, nextCity, productTourId = null, stopType){

        const { currentBooking, client, isLoading } = this.props;
        const parsed = queryString.parse(window.location.search);

        if(type === 'city'){

            //Set default nights for hub and city
            const nights = stopType === "hubCity" ? 3 : 2; 

            if(!isLoading) AddSector(client, currentBooking.uuid, getCyoaID(parsed), type, nextCity, nights, null, nextCity);
        }

        if(type === 'product'){
            this.props.ToggleSlidingPanel(false, true, false).then(() => {
                document.body.dispatchEvent(new CustomEvent('BUILDER_SECTOR_CLICK', { detail: productTourId }));
            });
        }

        //Scroll into view
        ReactDOM.findDOMNode(this).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

    }

    nextDestinationMsg(stops, firstDeparture){

        const viaText = stops.length > 1 ? " via" : "";
        let str = "";

        for(let i = 0; i < stops.length - 1; i++){
            str += ` ${stops[i].name} ${i !== stops.length - 2 ? 'and' : '' }`;
        }

        return (
            <>
            {`${viaText}${str.slice(0, -1)}, next departing on ` }
            <span className="bold black-text">{dayjs(firstDeparture).format('dddd, D MMM')}</span>
            </>
        )
    }


    renderWaitMsg(firstDeparture){

        const { currentBooking:{itinerary} } = this.props;

        const lastItineraryDate = dayjs(_last(itinerary).endDate);
        let waitTime = dayjs(firstDeparture).diff(lastItineraryDate, 'hour')-1;
      
        if(waitTime < 10) return null;
        return <p className="wait-button-text">
        {waitTime <= 24  && `${waitTime} hour wait`} 
        {waitTime > 24 && `${timeConverter(waitTime * 60)} wait`}
        </p>
  
    }

    render(){

        const { nextDestinations:{routes, products}, slidePanelActive, isGapActive } = this.props;
 
        const _routes =  (routes === undefined) ? [] : routes;
        const _products = (products === undefined) ? [] : products;
      
 
        return (
            <Fragment>
            <div className="destination-panel">
                <div className="panel small-panel no-border pl0">
                    <div className="clearfix">
                        <div className={`col col-11`}>
                            <p className={`bold f-size-16 pt1 itinerary`} onClick={() => this.props.toggleGapActive()}>Add Next Destination</p>
                        </div>

                        {(isGapActive && _routes.length !== 0) && <div className="col col-1 right-align pt1"><CloseSvg clazz={'button'} onClick={() => { this.props.toggleGapActive()}}/></div>}

                    </div>
                </div>
                
            { (isGapActive || _routes.length > 0) &&
                <div className="clearfix margin-t-20">
                        <div className="col col-12">
                            {
                                _routes.map((data, index) => {
                                    return(
                                        <Fragment key={index}>

                                            <div className="clearfix flex margin-b-10">
                                                <div className={`col flex items-center ${_routes.length === 1 ? 'col-12' : 'col-9'}`}>
                                                    <p className="f-size-12 medium">
                                                        <span className="bold">{data.name}</span>
                                                        {this.nextDestinationMsg(data.stops, data.firstDeparture)}
                                                    </p>
                                                </div>
        
                                                {
                                                    <div className="col col-3 flex items-center justify-end">
                                                        {this.renderWaitMsg(data.firstDeparture)}
                                                    </div>
                                                }
                                            </div>

                                            {
                                                data.stops.map((data) => {
                                                    return(
                                                        <BuilderCard
                                                            key={Math.random()}
                                                            id={'next-destination-view'}
                                                            showClose={false}
                                                            showPlus={true}
                                                            builderData={data}
                                                            onPlusClicked={() => this.onAddDestination("city", data.name, null, data.type)}
                                                            />
                                                    )
                                                })
                                            }

                                    
                                        </Fragment>    
                                    )
                                })
                            }
                        </div>

                    
                        <div className="col col-12">
                            {_products.length > 0 && <p className="bold f-size-16 margin-t-40 margin-b-30">Link up with these trips</p>}
                            {
                                _products.map((data, index) => {
                                    return (
                                        <Fragment key={index}>
                                            <p className="description-text medium margin-b-10">{data.name} route</p>

                                            <ProductCard
                                                id={'next-destination-view'}
                                                showClose={false}
                                                showPlus={true}
                                                builderData={data}
                                                onPlusClicked={() => this.onAddDestination("product", null, data.tourId, null)}
                                                />
                                        </Fragment>
                                    )
                                })
                            }
                        </div>
                    </div>
                }   
            </div>
            { slidePanelActive /*&& isGapActive*/ && <BuilderSlidePanel /> }
            </Fragment>
        )
        
    }
}


const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        nextDestinations:state.nextDestinations,
        slidePanelActive:state.toggleSlidePanel.builderIsOpen,
        isLoading:state.cart.update_sector_loading
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ToggleSlidingPanel
    }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(DestinationPanel));